export default "__VITE_ASSET__9389cad7__"